import creditCardType from "credit-card-type";

import { MASTERCARD, MAESTRO, VISA, AMEX, DISCOVER } from "./constants/brands";
import {
  Theme,
  CardSelectionType,
  SelectionType,
  HeaderTextType,
} from "./types";

export default {
  cardBrand: creditCardType.types.MASTERCARD,
  locale: "en_US",
  theme: Theme.dark,
  darkMode: false,
  allowedBrands: [MASTERCARD, MAESTRO, VISA, AMEX, DISCOVER],
  displayCancelOption: false,
  displayAddCard: false,
  displayPreferredCard: false,
  cardSelectionType: CardSelectionType.gridView,
  displayHeader: true,
  displayPayAnotherWay: true,
  displaySignOut: false,
  background: "default",
  selectionType: SelectionType.button,
  headerTextType: HeaderTextType.none,
  displayRememberMe: false,
  displayRememberMeConsent: true,
  dcfSuppressed: true,
  offers: [],
};

// Storybook defaults/config
export const storyDefaults = {
  // true = no iframe; false = iframe
  inlineStories: false,
  // utilized for locale control; alphabetized for use in doc generation
  localeOptions: [
    "bg_BG",
    "cs_CZ",
    "da_DK",
    "de_AT",
    "de_BE",
    "de_CH",
    "de_DE",
    "el_GR",
    "en_AE",
    "en_AU",
    "en_BE",
    "en_BH",
    "en_CA",
    "en_CH",
    "en_CZ",
    "en_DE",
    "en_EG",
    "en_ES",
    "en_GB",
    "en_HK",
    "en_HR",
    "en_IE",
    "en_IL",
    "en_IN",
    "en_IT",
    "en_JO",
    "en_KE",
    "en_KW",
    "en_NG",
    "en_NO",
    "en_NZ",
    "en_PH",
    "en_PL",
    "en_QA",
    "en_RS",
    "en_SA",
    "en_SE",
    "en_SG",
    "en_TH",
    "en_TZ",
    "en_US",
    "en_VN",
    "es_AR",
    "es_CL",
    "es_CO",
    "es_DO",
    "es_EC",
    "es_ES",
    "es_GT",
    "es_HN",
    "es_MX",
    "es_NI",
    "es_PA",
    "es_PE",
    "es_PY",
    "es_SV",
    "es_UY",
    "et_EE",
    "fi_FI",
    "fr_BE",
    "fr_CA",
    "fr_CH",
    "fr_FR",
    "hu_HU",
    "hr_HR",
    "it_CH",
    "it_IT",
    "lt_LT",
    "lv_LV",
    "ms_MY",
    "nb_NO",
    "nl_BE",
    "nl_NL",
    "pl_PL",
    "pt_BR",
    "pt_PT",
    "ro_RO",
    "sk_SK",
    "sr_RS",
    "sv_FI",
    "sv_SE",
    "th_TH",
    "uk_UA",
    "vi_VN",
    "zh_HK",
    "zh_SG",
  ],

  // utilized for error reasons control
  errorReasons: [
    "RETRIES_EXCEEDED",
    "CODE_INVALID",
    "ACCT_INACCESSIBLE",
    "INVALID_ERROR_REASON",
  ],

  cardBrandsOptions: ["mastercard", "visa", "amex", "discover"],
};
